import { Form, Formik } from 'formik';
import moment from 'moment';
import { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import ExportComponent from '../../components/common/ExportComponent';
import FilterDateComponent from '../../components/common/FilterDateComponent';

import DataTable from '../../components/common/DataTable';
import SingleView from '../../components/common/SingleView';
import { TextArea } from '../../components/Form/Form';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import {
  LINK_URL,
  PAGE_SINGLE_TITLE,
  PAGE_TITLE,
  SIDEBAR_OPTIONS,
  inputFields,
  view_all_table,
} from '../../shared/enums/leads_enum';
import { UseDataForExcel, UseFilter } from '../../shared/hooks/UseExcel';
import { useAllLeads, useGetDropdownOptions } from '../../shared/hooks/UseLead';
import {
  useAllLeadComments,
  useCreateLeadcomment,
} from '../../shared/hooks/UseLeadcomment';
import { convertToFormData } from '../../shared/upload';
import TableSection from '../../utils/table-section';

const AllLeads = ({}) => {
  const [data, setPageNumber, deleteBtnClicked] = useAllLeads();
  const { leads_loading, leads, total_leads, page, pages } = data;
  const [
    dropdownOptions,
    // setClientSearchField, setClientSearchValue
  ] = useGetDropdownOptions();
  const loadOptions = async (inputValue, callback, field) => {
    // if (field == "client") {
    //   await setClientSearchField("name");
    //   await setClientSearchValue(inputValue);
    //   callback(dropdownOptions.client);
    // }
  };

  const [comment_data, setLead, setReloadComments] = useAllLeadComments();
  const { leadcomments, leadcomments_loading } = comment_data;
  const [commentData, addData] = useCreateLeadcomment();
  const submitFormClicked = async (values) => {
    const data = await convertToFormData({ values });
    await addData(data);
    setReloadComments(true);

    // history.push(`/${LINK_URL}`);
  };

  const [exportXLSXData] = UseFilter();

  const [convertToReadable, exportData] = UseDataForExcel();

  useEffect(() => {
    if (leads) {
      convertToReadable(leads, inputFields);
    }
  }, [leads]);

  const handleOnExport = () => {
    exportXLSXData(exportData, 'Leads', 'leads');
  };
  const userData = useSelector((state) => state.auth);
  const { user } = userData;

  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState(null);

  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_TITLE}
          mainLinkTitle='Dashboard'
          mainLinkUrl='/dashboard'
          activeLink={PAGE_TITLE}
        />
        <ExportComponent handleOnExport={handleOnExport} />
        {user && (
          <FilterDateComponent
            link='/leads'
            showOwn={true}
            searchParams={{ term: 'created_by', value: user._id }}
          />
        )}

        <TableSection
          SIDEBAR_OPTIONS={SIDEBAR_OPTIONS}
          dropdownOptions={dropdownOptions}
          loadOptions={loadOptions}
          total_data={total_leads}
          data={leads}
          data_loading={leads_loading}
          page={page}
          pages={pages}
          setPageNumber={setPageNumber}
          deleteBtnClicked={deleteBtnClicked}
          view_all_table={view_all_table}
          inputFields={inputFields}
          PAGE_TITLE={PAGE_TITLE}
          PAGE_SINGLE_TITLE={PAGE_SINGLE_TITLE}
          LINK_URL={LINK_URL}
          DataTable={DataTable}
          TABLE_TITLE='Leads Management'
        />
      </div>
      <ReactModal
        isOpen={modal}
        contentLabel='Modal'
        className='Modal'
        overlayClassName='Overlay'
        onRequestClose={() => {
          setModal(false);
        }}
      >
        <div className='quick-view'>
          <div className='qv-header'>
            <div className='title'> {PAGE_SINGLE_TITLE} </div>
            <div>
              <button
                onClick={() => {
                  setModal(false);
                }}
                className='btn btn-primary'
              >
                <i className='fa fa-times'></i>
              </button>
            </div>
          </div>
          {modalData && (
            <>
              <div className='qv-body'>
                <SingleView
                  hideGallery={true}
                  data={modalData}
                  inputFields={inputFields}
                  label={PAGE_SINGLE_TITLE}
                  link={LINK_URL}
                  id={modalData._id}
                  hideAllBtn={true}
                  col={12}
                />
                <div className='card'>
                  <div className='card-body'>
                    <Formik
                      initialValues={{
                        comment: '',
                      }}
                      validationSchema={Yup.object({
                        comment: Yup.string().required('Required'),
                      })}
                      onSubmit={async (
                        values,
                        { setSubmitting, resetForm }
                      ) => {
                        setSubmitting(true);
                        values.activity = modalData._id;
                        await submitFormClicked(values);
                        resetForm();
                        setSubmitting(false);
                      }}
                    >
                      {(formik) => {
                        console.log(formik);
                        return (
                          <Form>
                            <div className='row align-items-center'>
                              <div className='col-md-9'>
                                <TextArea
                                  label='Comment'
                                  name='comment'
                                  type='text'
                                />
                              </div>
                              <div className='col-md-3'>
                                <button
                                  type='submit'
                                  className='btn btn-success'
                                >
                                  {' '}
                                  {formik.isSubmitting
                                    ? 'SAVING...'
                                    : 'SAVE'}{' '}
                                </button>
                              </div>
                            </div>
                          </Form>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
                <div className='card'>
                  <div className='card-body'>
                    <table className='table table-stripped'>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Comment</th>
                          <th>Comment By</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!leadcomments_loading ? (
                          <>
                            {leadcomments &&
                              leadcomments.map((item, index) => {
                                return (
                                  <tr>
                                    <td> {index + 1} </td>
                                    <td> {item.comment} </td>
                                    <td>
                                      {' '}
                                      {item.created_by &&
                                        item.created_by.name}{' '}
                                    </td>
                                    <td>
                                      {' '}
                                      {item.createdAt &&
                                        moment(item.createdAt).format(
                                          'DD-MM-YYYY hh:mm A'
                                        )}{' '}
                                    </td>
                                  </tr>
                                );
                              })}
                          </>
                        ) : (
                          <>
                            <p> Loading... </p>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </ReactModal>
    </div>
  );
};

export default AllLeads;
